import { ColumnsType } from 'antd/es/table'
import { Sorter } from '../../../../components/Sorter/Sorter'
import { SortOrder } from 'antd/es/table/interface'
import { THealthSystem, THealthSystemColumnsProps } from './types'
import { ActionCell } from './ActionCell'
import { Chips } from '../../../../components/Chips/Chips'
import { routes } from '../../../../router'
import { Link } from '../../../../components/Link'
import { CREATE_EDIT_HS_TABS } from '../HSDetails/constants'
import {
  ability,
  ACTIONS,
  SUBJECTS,
  SubjectWithAttributes
} from '../../../Permission'
import { subject } from '@casl/ability'

export const columns = ({
  userHS,
  canSeeActionColumn
}: THealthSystemColumnsProps): ColumnsType<THealthSystem> => {
  const columns: ColumnsType<THealthSystem> = [
    {
      dataIndex: 'name',
      key: 'name',
      title: ({ sortOrder, sortColumn }) => (
        <Sorter<THealthSystem>
          dataIndex="name"
          sortColumn={sortColumn}
          sortOrder={sortOrder as SortOrder}
        >
          Health system
        </Sorter>
      ),
      sorter: true,
      showSorterTooltip: false,
      render: (_, { name, uuid }) => (
        <>
          <Link
            to={`${routes.myCommunity}${routes.myOrganization}/health_systems/${uuid}`}
            state={{ redirectTab: CREATE_EDIT_HS_TABS[0].key }}
          >
            {name}
          </Link>
          <br />
          {userHS && userHS === uuid && (
            <Chips grey key={uuid}>
              My health system
            </Chips>
          )}
        </>
      )
    }
  ]

  if (canSeeActionColumn) {
    columns.push({
      dataIndex: 'action',
      key: 'action',
      width: 64,
      fixed: 'right',
      render: (_, hs) => {
        const canSeeHSActions = ability.can(
          ACTIONS.VIEW,
          subject(SUBJECTS.MY_ORGANIZATION_COMMUNITY_HS_TABLE_ACTIONS, {
            uuid: hs.uuid
          } as unknown as SubjectWithAttributes)
        )
        return canSeeHSActions ? <ActionCell hsUuid={hs.uuid} /> : null
      }
    })
  }

  return columns
}
